import { FaTrashAlt } from "react-icons/fa";
import { useContext } from "react";
import { TechsContexts } from "../../contexts/TechsContext";
import { StyledTech } from "./styles";

interface ITech {
  id: string;
  title: string;
  status: string;
}

export const Tech = ({ id, title, status }: ITech) => {
  const { removeTech } = useContext(TechsContexts);
  const tech = {
    id: id,
    title: title,
    status: status,
  };

  return (
    <StyledTech>
      <h3>{title}</h3>
      <div>
        <span>{status}</span>
        <button type="button" onClick={() => removeTech(tech)}>
          <FaTrashAlt />
        </button>
      </div>
    </StyledTech>
  );
};
